import * as React from "react";

function SvgAppNexus(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 158 158.713"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="#F89938"
        d="M158.063 146.746c0 6.251-5.067 11.319-11.318 11.319H14.013c-6.25 0-11.318-5.068-11.318-11.319V14.016c0-6.251 5.068-11.318 11.318-11.318h132.731c6.251 0 11.318 5.067 11.318 11.318v132.73z"
      />
      <path d="M146.743.002H14.013C6.272.003.001 6.274-.001 14.016v132.731c.002 7.739 6.273 14.01 14.014 14.012h132.73c7.74-.002 14.012-6.272 14.015-14.012V14.016C160.755 6.274 154.483.003 146.743.002zM5.39 55.125c27.142.606 51.608 11.833 69.498 29.714 18.106 18.115 29.386 42.978 29.728 70.531H60.678c-.666-30.463-24.962-55.089-55.288-56.287V55.125zM56.142 5.392h43.938c.666 30.463 24.961 55.088 55.287 56.288v43.958c-27.141-.607-51.607-11.834-69.497-29.715C67.763 57.808 56.483 32.945 56.142 5.392zm99.224 8.624v35.797c-11.728-.582-22.254-5.56-30.044-13.342-8.009-8.018-13.034-18.937-13.369-31.079h34.79a8.635 8.635 0 018.623 8.624zM14.013 5.392h30.271c.208 18.646 4.912 36.211 13.082 51.661-15.49-8.461-33.171-13.41-51.976-13.787v-29.25a8.633 8.633 0 018.623-8.624zM5.39 146.747v-35.798c11.729.582 22.254 5.56 30.045 13.342 8.009 8.018 13.034 18.937 13.369 31.079H14.013a8.634 8.634 0 01-8.623-8.623zm141.353 8.623h-30.27c-.207-18.646-4.911-36.21-13.082-51.66 15.49 8.46 33.171 13.409 51.975 13.786v29.251a8.636 8.636 0 01-8.623 8.623z" />
    </svg>
  );
}

export default React.forwardRef(SvgAppNexus);
